import { useState, useEffect, useMemo } from 'react';
import { Button, Modal } from '@bfe/moly';
import cls from 'classnames';
import { permissionStore } from '@web3fe/infra';
import { useFm, useParams, useNavigate } from '@web3/base-hooks';
import { appPath } from '@web3/base-utils';

import styles from './index.module.scss';

interface Props {
  show: boolean;
  onClose: () => void;
}

export const BanModal = (props: Props) => {
  const { navigateToPcPage } = useNavigate();

  const toDetail = () => {
    navigateToPcPage('/detail');
  };

  const { show, onClose } = props;
  const fm = useFm();
  const { locale, activityId } = useParams();

  const toHome = () => {
    window.location.href = `${window.location.origin}/${locale}${appPath}`;
  };

  const isUSBan = useMemo(() => {
    if (!permissionStore.state.countryCode) return;

    if (
      activityId === '228' &&
      ['US'].includes(permissionStore.state.countryCode)
    ) {
      return true;
    }
  }, [permissionStore.state.countryCode]);

  // const isBan = useMemo(() => {
  //   if (!permissionStore.state.countryCode) return;

  //   if (
  //     activityId === '228' &&
  //     ['US'].includes(permissionStore.state.countryCode)
  //   ) {
  //     return true;
  //   }

  //   if (
  //     activityId === '231' &&
  //     !['HK'].includes(permissionStore.state.countryCode)
  //   ) {
  //     return true;
  //   }
  // }, [permissionStore.state.countryCode]);

  return (
    <Modal
      open={show}
      title={fm('ipAddressRestricted')}
      footer={null}
      size="small"
      onClose={onClose}
    >
      <div className={styles.desc}>{fm('airdropEventUnavailableTip')}</div>
      <Button
        className={cls('mt-6 w-full')}
        variant="primary"
        size="middle"
        onClick={onClose}
      >
        {fm('i_know')}
      </Button>
    </Modal>
  );
};
